<template>
  <div>
    <b-container fluid>


      <div class="row main">
        <DashboardMobile :items="menuItems"></DashboardMobile>
        <DashboardDesktop :items="menuItems"></DashboardDesktop>

        <div class="col-lg-10  d-lg-block w-100 ">
          <section id="intro" class="clearfix">
            <div class="container-fluid">

              <div class="intro-left">

                <slot></slot>

              </div>

            </div>

          </section>
        </div>

      </div>

    </b-container>
  </div>
</template>

<script>
import DashboardMobile from "./DashboardMenu/mobile";
import DashboardDesktop from "./DashboardMenu/desktop";

export default {
  name: "Layout",
  components: {DashboardMobile, DashboardDesktop},
  props: ['menuItems']
}
</script>

<style scoped>

ul li {
  list-style: none;
}


ul li a:focus {

  color: #7f9afd;

}

ul li a {
  color: #7f807d;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 15px;
  outline: none;
}


img {
  vertical-align: middle;
  border-style: none;
}

.main-nav > ul > li {
  position: relative;
  white-space: nowrap;
  /*float: right;*/
}

.main-nav a {
  display: block;
  position: relative;
  color: #131313;
  padding: 7px 20px;
  transition: 0.3s;
  font-size: 16px;

}

#intro {
  padding: 30px 0 60px 0;
}

#intro {

  position: relative;
  background-size: cover;
  /*padding: 180px 0 60px 0;*/
  background: #f5f5f5;
  height: 100%;
}

nav, section {
  display: block;
}

.mobile-nav-active .mobile-nav {
  left: 0;
  color: white;
}

nav {
  display: block;
}

.mobile-nav a {
  z-index: 1000000;
  display: block;
  position: relative;
  color: #fff;
  padding: 10px 20px;
  font-weight: 500;
}


.main {
  padding-top: 2%;
  padding-bottom: 2%;
}

</style>